module.exports = __webpack_public_path__ + "img/cypress.5d7b8533.png";